import config from '../config'
import fetch from 'isomorphic-fetch'

export async function unauthInvokeApig (
  { service,
    path,
    method = 'GET',
    body}) {
  const url = `https://${config.HOST}/${config.ENV}${path}`
  const headers = {}
  body = (body) ? JSON.stringify(body) : body
  const results = await fetch(url, {
    method,
    body,
    headers
  })

  if (results.status !== 200) {
    throw new Error(await results.text())
  }
  return results.json()
}

export async function invokeApig (
  { service,
    path,
    method = 'GET',
    body}, userToken) {

	if (!userToken) {
		return null
	}

	const url = `https://${config.HOST}/${config.ENV}${path}`
	const headers = {
		Authorization: userToken,
		"Content-Type" : "application/json",
		Accept: 'application/json'
	}
	body = (body) ? JSON.stringify(body) : body

	const results = await fetch(url, {
		method,
		body,
		headers
	})

	if (results.status !== 200) {
		throw new Error(await results.text())
	}
	return results.json()
}

export async function invokeApigFormData (
  { service,
    path,
    method = 'GET',
    body}, userToken) {

	if (!userToken) {
		return null
	}

	const url = `https://${config.HOST}/${config.ENV}${path}`
	const headers = {
		Authorization: userToken,
	}
	const results = await fetch(url, {
		method,
		body,
		headers
	})

	if (results.status !== 200) {
		throw new Error(await results.text())
	}
	return results.json()
}